<template>
  <v-content
    width="360px"
  >
    <div
      width="360px"
    >
      <!-- <a
        v-if="!item.Menus || item.Menus.length === 0"
        @click="handleMenuClick(item)"
      >
        <menu-header
          :name="item.Name"
        />
      </a> -->
      <v-expansion-panels
        width="360px"
        :multiple="false"
        class="list-group-item"
      >
        <v-expansion-panel
          v-for="(item, i) in data"
          :key="i"
          style="margin:0;"
          :style="{
            'background-color': isSecundary ? BGColorSecundary : BGColor, 
          }"
        >
          <v-expansion-panel-header
            v-slot="{ open }"
            v-if="!item.HideDesktop || item.HideDesktop === 0"
            expand-icon=""
            style="padding: 0;"
            :style="{ 
              'border-radius': `0 0 0 0`,
              'cursor': isSimulation && !isSecundary ? 'move !important' : 'pointer !important',
              'font-family': isSecundary ? FontSecundary : Font,
              'font-size': isSecundary ? `${FontSizeSecundary}px` : `${FontSize}px`,
              'background-color': isSecundary ? BGColorSecundary : BGColor, 
              'color': isSecundary ? ColorSecundary : Color, 
              'background-image': ((isSecundary && withGradientSubmenu) || (!isSecundary && withGradient)) ? 'linear-gradient(to top, rgba(128, 128, 128, 0.0), rgba(0, 0, 0, 0.2))' : '',
              'border-bottom': withLine ? `0.5px solid ${getColor()}` : '',
              'border-top': withLine ? `0.5px solid ${getColor()}` : ''
            }"
            @click="handleMenuClick(item)"
          >
            <menu-header
              :name="item.Name"
            />
          </v-expansion-panel-header>
          <v-expansion-panel-content
            v-if="item.Menus"
            style="padding:0!important;"
          >
            <a
              v-for="(submenu, i) in item.Menus.filter(x => !x.HideDesktop)"
              :key="i"
              @click="handleMenuClick(submenu)"
            >
              <menu-header
                :name="submenu.Name"
                :isSecundary="true"
              />
            </a>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
      <!-- <div
        v-for="(submenu, i) in item.Menus"
        :key="i"
      >
        <a @click="handleMenuClick(submenu)">
          <menu-header
            :name="submenu.Name"
            :isSecundary="true"
          />
        </a>
      </div> -->
    </div>
    <external-link
      v-if="externalLink"
      :item="externalLink"
      :locale="locale"
      :showDialog="showExternalLink"
      :onClose="handleCloseExternalLink"
      :bgColor="BGColor"
    />
  </v-content>
</template>

<script>
  import { mapState } from 'vuex'
  import utils from '@/services/utils'
  import constants from '@/constants'
  import MenuHeader from '../MenuHeader'
import ExternalLink from '../../totemMainMenu/ExternalLink'
  export default {
    components: {
      MenuHeader,
      ExternalLink,
    },
    props: {
      data: {
        type: Array,
        required: false,
        default: null
      },
      onMenuChange: {
        type: Function,
        required: true
      }
    },
    data: () => ({
      isSecundary: false,

      showExternalLink: false,
      externalLink: null,
    }),
    computed: {
      ...mapState('app',['locale', 'withLine', 'withGradient', 'withGradientSubmenu','BGColor', 'Color', 'BGColorSecundary', 'ColorSecundary', 'GlobalFont', 'FontSecundary', 'FontSizeSecundary', 'Font', 'FontSize', ]),      
      isSimulation () {
        return constants.simulationsRutes.indexOf(this.$route.path.split('/')[1]) >= 0
      },
    },
    mounted () {
      
    },
    methods: {
      handleCloseExternalLink () {
        this.showExternalLink = false
      },
      handleMenuClick (menu) {
        if (menu.WebAppAsLink) {
          let url = ''
            if (menu.WebAppAsContentDomain.indexOf('.') > 0) url = menu.WebAppAsContentDomain
            else {
              url = `${window.location.protocol}//${menu.WebAppAsContentDomain}.${process.env.VUE_APP_API_URL}`
              url += '#/?back='+utils.getDomain()
              if (this.locale !== 'es') url += '&locale=' + this.locale
            }
          this.externalLink = {
            externalLink: {
              es: url
            }
          }
          this.showExternalLink = true
          // if totem open as modal
            // window.location.href = url
        } else {
          if (!menu.IsMenuWithSubmenu) this.onMenuChange(menu)
        }
      },
      getColor () {
        if (this.isSecundary) {
          if (this.ColorSecundary && this.ColorSecundary.length >= 7) {
            return this.ColorSecundary.substring(0, 7).concat('4d')
          }
          return this.ColorSecundary
        } else {
          if (this.Color && this.Color.length >= 7) {
            return this.Color.substring(0, 7).concat('4d')
          }
          return this.Color
        }
      },
    }
  }
</script>
<style lang="scss">
.totem .v-expansion-panel-content__wrap {
  padding:0 !important;
}
</style>
